import { render, staticRenderFns } from "./EditModuleTemplate.vue?vue&type=template&id=47ecff1a&scoped=true"
import script from "./EditModuleTemplate.vue?vue&type=script&lang=js"
export * from "./EditModuleTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditModuleTemplate.vue?vue&type=style&index=0&id=47ecff1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ecff1a",
  null
  
)

export default component.exports